// @charset "UTF-8";
const es = {
    idioma:"Idioma",
    idiomas: {
        en: "Inglés",
        es: "Español",
       
    },
    home: {
        repoInv: "Repositorio de Investigadores",
        uAcademica: "Unidades Académicas",
        cInvestigacion: "Centros de Investigación Institucionales",
        estadisticas: "Estadísticas",
        ods: "ODS",
    },
    investigador: {
        nombre: "Nombre",
        metricas: "Métricas",
        publicaciones: "Publicaciones",
        citaciones: "Citaciones",
        colaboradores: "Colaboradores",
        proyectos: "Proyectos",
        areas: "Áreas de Investigación",
        noareas: "No Áreas",
        investigador: "Investigador",
        colaboraciones: "Colaboraciones"
    },
    unidad: {
        investigadores: "Investigadores",
        hombres: "Hombres",
        mujeres: "Mujeres",

    },
    publicacion: {
        titulo: "Título",
        publicacion:"Publicación",
        fecha: "Fecha",
        journal: "Journal",
        articlenum: "Artículo num",
        investigadoresEspol: "Investigadores ESPOL",
        otrosAutEspol: "Otros Autores Espol",
        otrosAut: "Otros Autores",
        creador: "Creador",
        primerAutor: "Primer Autor",
        anio:"Año"
    },
    proyecto: {
        titulo: "Título",
        proyecto: "Proyecto",
        fechain: "Fecha inicio",
        fechafin: "Fecha fin",
        participante: "Participantes",
        nombre: "Nombre",
        colaboradoresEs: "Colaboradores ESPOL",
        colaboradoresEx: "Colaboradores externos",
        insEspol: "Instituciones colaboradoras ESPOL",
        exInsEspol: "Instituciones colaboradoras externas",
        rol: "Rol",
        area: "Área",
        subarea: "Subárea",
        unidad: "Unidad",
        tipoI: "Tipo",
        institucion: "Institución",
        estado: "Estado",
        creador: "Creador"
    },
    estadisticas: {
        investigadores: "Investigadores",
        pubAnuales: "Publicaciones Anuales",
        citAnuales: "Conteo de Citas",
        proyAnuales: "Proyectos Vigentes",
        hombres: "Hombres",
        mujeres :"Mujeres"
    },
    ods: {
        datos: "Datos",
        publicaciones: "Publicaciones"
    },
    busqueda: {
        key: "Palabras clave",
        autor: "Investigador"
    }
   
};

export default es;